<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      合同管理
      <small>
        /&nbsp;
        <router-link to="/contract" class="TitleStyle">合同管理列表</router-link>/&nbsp;合同详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">合同详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">合同详情</span>
                  </div>
                  <el-form
                    :model="ruleForm"
                    :inline="true"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="150px"
                    class="demo-form-inline"
                  >
                    <div class="GContent">
                      <!-- 1 -->
                      <el-row>
                        <el-col :span="12">
                          <div class="grid-content bg-purple">
                            <el-form-item label="合同编号:" class="labelstyle">
                              <el-input
                                v-model="ruleForm.contractNo"
                                class="DistributorMargin InputWidth"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="合同标题:" class="labelstyle">
                              <el-input
                                v-model="ruleForm.contractTitle"
                                class="DistributorMargin InputWidth"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <!-- 2 -->
                      <el-row>
                        <el-col :span="12">
                          <div class="grid-content bg-purple">
                            <el-form-item label="合作区域:" class="labelstyle">
                              <el-input
                                v-model="ruleForm.contractScopeName"
                                class="DistributorMargin InputWidth"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="合同品类:" class="labelstyle">
                              <el-input
                                v-model="ruleForm.goodsName"
                                class="DistributorMargin InputWidth"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <!-- 3 -->
                      <el-row>
                        <el-col :span="12">
                          <div class="grid-content bg-purple">
                            <el-form-item label="客户类型:" class="labelstyle">
                              <el-input
                                v-model="ruleForm.recomTypeName"
                                class="DistributorMargin InputWidth"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="客户名称:" class="labelstyle">
                              <el-input
                                v-model="ruleForm.recomName"
                                autocomplete="new-password"
                                class="DistributorMargin InputWidth"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <!-- 4 -->
                      <el-row>
                        <el-col :span="12">
                          <div class="row_four-left">
                            <el-form-item label="企业合同上传时间:" class="labelstyle">
                              <span class="span_left">{{ruleForm.inputTime}}</span>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="row_four_buttom_right">
                            <el-form-item label="客户合同上传时间:" class="labelstyle">
                              <span class="span_left">{{ruleForm.inputTime1}}</span>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <!-- 5 -->
                      <el-row>
                        <el-col :span="12">
                          <div class="row_four_buttom">
                            <el-form-item label="企业合同书：" class="labelstyle">
                              <a
                                href="javascript:;"
                                class="btn btn-primary btn-sm ButtonColor span_left1"
                                @click="qy()"
                              >下载企业合同书</a>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="row_four_buttom_right">
                            <el-form-item label="客户合同书:" class="labelstyle">
                              <a
                                href="javascript:;"
                                class="btn btn-primary btn-sm ButtonColor span_left"
                                @click="kh()"
                              >下载客户合同书</a>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <div class="clear"></div>
                      <div class="upload">
                        <div class="upload_left">备注：</div>
                        <div class="upload_right">
                          <el-input
                            v-model="ruleForm.Remark"
                            type="textarea"
                            class="DistributorMargin InputWidth1"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </el-form>
                </div>
                <div style="height:46px;padding-top:16px;text-align:right;">
                  <button
                    class="swal-button swal-button--confirm btn btn-primary ButtonColor"
                    @click="GoBack"
                  >返回</button>
                  <span class="clear"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "contractdetail",
  data() {
    return {
      ruleForm: {
        contractNo: "",
        contractTitle: "",
        contractScopeName: "",
        signTime: "",
        goodsName: "",
        recomTypeName: "",
        recomName: "",
        contractFileUrl: "",
        contractTerm: "",
        contractStatus: 0,
        status: 1,
        // 备注
        Remark: "",
        // 保证金额
        money: "",
        inputTime: "",
        inputTime1: ""
      },
      rules: {},
      bankList: [],
      disabled: false,
      bankCityoptions: [],
      pageNo: 1,
      pageSize: 10,

      // 新增品类
      GroupList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      // 合同类型
      typeList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      ProvincesList: [],
      bankType: [
        {
          label: "一类户",
          value: "P"
        }
      ],
      cityList: [],
      countryList: [],
      CityShow: false,
      CountiesShow: false,
      mallTypee: [1, 2],
      auditTypePC: "1",
      auditTypeO2O: "1",
      openSettingsFormList: "",
      datadetail: []
    };
  },
  mounted() {
    this.initdata();
  },

  methods: {
    // 初始化数据
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobContractController/selectContractDetails",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          // 获取url中的contractId -----必填项
          contractId: this.$route.query.contractId
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
             if(response.data.data.recomType == 0){
                that.ruleForm.recomTypeName  ="分销商"
             }
             if(response.data.data.recomType == 1){
                that.ruleForm.recomTypeName  ="服务商"
             }
          this.ruleForm.contractNo = JSON.parse(
            this.$route.query.data
          ).contractNo;
          this.ruleForm.contractTitle = JSON.parse(
            this.$route.query.data
          ).contractTitle;
          this.ruleForm.recomName = JSON.parse(
            this.$route.query.data
          ).recomName;
          this.ruleForm.Remark = JSON.parse(
            this.$route.query.data
          ).contractRemark;
          this.datadetail = JSON.parse(this.$route.query.data).tobFilesList;
          this.ruleForm.goodsName = JSON.parse(
            this.$route.query.data
          ).goodsName;
          this.ruleForm.contractScopeName =
            JSON.parse(this.$route.query.data).province +
            " " +
            JSON.parse(this.$route.query.data).city;
          if (JSON.parse(this.datadetail[0].mark == 1)) {
            this.ruleForm.inputTime = JSON.parse(
              this.$route.query.data
            ).tobFilesList[0].inputTime;
          }
          if (JSON.parse(this.datadetail[0].mark == 2)) {
            this.ruleForm.inputTime1 = JSON.parse(
              this.$route.query.data
            ).tobFilesList[0].inputTime;
          }
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    // 合同区域
    handleChange(value) {
      // this.ruleForm.contractScopeName = value;
      // console.log(value);
    },
    // 下载企业合同
    qy() {
      if (this.datadetail[0].fiteUrl && JSON.parse(this.datadetail[0].mark == 1 )) {
        window.open(this.datadetail[0].fiteUrl);
      }
    },
    //  下载客户合同
    kh() {
     if (this.datadetail[0].fiteUrl && JSON.parse(this.datadetail[0].mark == 2)) {
        window.open(this.datadetail[0].fiteUrl);
      }
    },
    // GoBack() {
    //   this.$router.push({ name: "contract", path: "/contract" });
    // }
    Goback() {
      this.$router.push({
        name: that.$route.query.url,
        params: { pageNo: this.pageNo, pagesize: this.pageSize }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
  list-style: none;
}
.upload {
  margin-left: 5%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  margin-top: 50px;
  padding-right: 20px;
  letter-spacing: 1px;
}
.upload_right {
  margin-top: 45px;
  margin-left: 20px;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 30px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.row_four_buttom {
  margin-left: 1%;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width: 1360px) and (max-width: 1680px) {
  /*二栏布局*/
  .TableContent {
    width: 50%;
  }
}
@media screen and (min-width: 1680px) and (max-width: 2000px) {
  /*二栏布局*/
  .TableContent {
    width: calc(100% / 3);
  }
}
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.BackButton {
  float: right;
  cursor: pointer;
  color: #fff !important;
}
.InputWidth {
  width: 300px;
}
.InputWidth1 {
  width: 1080px;
}
.labelstyle {
  float: left;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #8c939d;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ReceiptTableTitle {
  list-style: none;
  float: left;
  color: #909399;
  padding: 12px 32px;
  border: 1px solid #ebeef5;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;

  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  width: 20%;
}
.span_left {
  margin-left: 20px;
}
.span_left1 {
  margin-left: 12px;
}

.ReceiptTableContent {
  padding: 12px 32px;
  list-style: none;
  float: left;
  font-size: 14px;
  line-height: 24px;
  height: 54px;
  color: #606266;
  overflow: hidden;
  user-select: none;
  text-align: left;
  background-color: #fff;
  width: 20%;
  border: 1px solid #ebeef5;
}
@media screen and (min-width: 1200px) and (max-width: 1310px) {
  .InputWidth {
    width: 280px;
  }
}
.kfSetting {
  padding: 10px 30px;
}
.settingValue {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/contractdetail.vue